export function isUpload(creation) {
  return creation && creation.style && creation.style[0] === "upload";
}

export function getCreationBucket(creation) {
  return isUpload(creation) ? "jobs" : "creations";
}

export function getImagePath(imgPath: string, showThumbnail = false, isUpload = false) {
  if (showThumbnail && !isUpload) {
    const split = imgPath.split("/");
    if (imgPath.startsWith("tattoos/")) {
      if (split.length === 3) {
        return `tattoos/${split[1]}/thumbnail/${split[2]}`;
      }
      return `tattoos/${split[1]}/${split[2]}/thumbnail/${split[3]}`;
    }
    return `${split[0]}/thumbnail/${split[1]}`;
  }
  return imgPath;
}

export function getFirstLikeIndex(creation) {
  return creation.likes && creation.likes.length ? creation.likes[0].like_idx : 0;
}
